import React from 'react';
import { OpportunityForm } from './OpportunityForm';
import { OpportunitiesList } from './OpportunitiesList';

export function OpportunitiesScreen() {
  const [showForm, setShowForm] = React.useState(true);

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl shadow-lg p-6">
        <div className="flex border-b border-gray-200 mb-6">
          <button
            onClick={() => setShowForm(true)}
            className={`px-4 py-2 font-medium text-sm border-b-2 -mb-px ${
              showForm
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            Cadastrar Oportunidade
          </button>
          <button
            onClick={() => setShowForm(false)}
            className={`px-4 py-2 font-medium text-sm border-b-2 -mb-px ${
              !showForm
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            }`}
          >
            Lista de Oportunidades
          </button>
        </div>

        {showForm ? <OpportunityForm /> : <OpportunitiesList />}
      </div>
    </div>
  );
}